import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const MainLayoutStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  box-sizing: border-box;
  padding-top: ${VARIABLES.ELEMENT_SIZES.HEADERBAR_HEIGHT + 'px'};
  padding-left: ${VARIABLES.ELEMENT_SIZES.SIDEBAR_WIDTH + 'px'};
  background-color: #f1f2f8;
  min-height: 100%;
  width: 100%;
  max-width: 100%;
  min-width: 0;

  /* demo */
  display: flex;
  align-items: stretch;
  /* position: fixed; */

  /* Child element styles
  ------------------------------- */
  .main-wrapper {
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding: 32px;

    /* demo */
    & > div {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 100%;
      min-width: 0;
      gap: 24px;
    }
  }

  /* Modifiers
  ------------------------------- */
  &.is-login-layout {
    padding-left: 0;

    .main-wrapper {
      padding: 0;
    }
  }

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1600.98px) {
    padding-top: ${VARIABLES.ELEMENT_SIZES.HEADERBAR_HEIGHT_XL + 'px'};
    padding-left: ${VARIABLES.ELEMENT_SIZES.SIDEBAR_WIDTH_XL + 'px'};

    .main-wrapper {
      padding: 32px;
    }
  }

  @media all and (max-width: 1440.98px) {
    padding-top: ${VARIABLES.ELEMENT_SIZES.HEADERBAR_HEIGHT_LG + 'px'};
    padding-left: ${VARIABLES.ELEMENT_SIZES.SIDEBAR_WIDTH_LG + 'px'};

    .main-wrapper {
      padding: 32px;
    }
  }

  @media all and (max-width: 1366.98px) {
    padding-top: ${VARIABLES.ELEMENT_SIZES.HEADERBAR_HEIGHT_MD + 'px'};
    padding-left: ${VARIABLES.ELEMENT_SIZES.SIDEBAR_WIDTH_MD + 'px'};

    .main-wrapper {
      padding: 32px;
    }
  }

  @media all and (max-width: 1280.98px) {
    padding-top: ${VARIABLES.ELEMENT_SIZES.HEADERBAR_HEIGHT_SM + 'px'};
    padding-left: ${VARIABLES.ELEMENT_SIZES.SIDEBAR_WIDTH_SM + 'px'};

    .main-wrapper {
      padding: 32px;
    }
  }

  @media all and (max-width: 1024.98px) {
    padding-top: ${VARIABLES.ELEMENT_SIZES.HEADERBAR_HEIGHT_XS + 'px'};
    padding-left: ${VARIABLES.ELEMENT_SIZES.SIDEBAR_WIDTH_XS + 'px'};

    .main-wrapper {
      padding: 16px;
    }
  }
`
